import { Button, Flex, SkeletonBox, Space, Spacing } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { getBankLineDescription } from '@features/bankTransactions/utils/getBankLineDescription'
import { ReconciliationSuggestion } from '@modules-deprecated/bankReconciliation/types'

import { ReconciliationSuggestionLine } from '../../../paymentReconciliationModal/elements/ReconciliationSuggestionLine'
import { PayableSubjectType } from '../../../paymentReconciliationModal/types/payableSubjectType'
import { SubjectReconciliationSuggestion } from '../SubjectReconciliationSuggestion'
import * as Styled from './styles'

interface SubjectReconciliationSuggestionCardProps {
  handleAcceptSuggestion: () => void
  handleRejectSuggestion: () => void
  isProcessingSuggestion?: boolean
  isProcessingDelete?: boolean
  isProcessingReconcile?: boolean
  subjectType?: PayableSubjectType | null
  suggestions?: ReconciliationSuggestion[]
}

export const SubjectReconciliationSuggestionCard = ({
  handleAcceptSuggestion,
  handleRejectSuggestion,
  isProcessingSuggestion,
  isProcessingDelete,
  isProcessingReconcile,
  subjectType,
  suggestions,
}: SubjectReconciliationSuggestionCardProps): ReactElement | null => {
  const { t } = useTranslation()

  const reconciliationTransaction = useMemo(() => suggestions?.[0]?.transactions?.[0], [suggestions])

  if (!suggestions?.length) {
    return null
  }

  return (
    <>
      <SubjectReconciliationSuggestion subjectType={subjectType} withIcon>
        <Styled.ReconciliationSuggestionContent>
          {reconciliationTransaction ? (
            <ReconciliationSuggestionLine
              title={getBankLineDescription(reconciliationTransaction.description)}
              amount={reconciliationTransaction.amount}
              date={reconciliationTransaction.bank_date}
              currency={reconciliationTransaction.currency}
            />
          ) : (
            <SkeletonBox fullWidth />
          )}
          <Flex justifyContent="center" alignItems="center" gap={Spacing.S12}>
            <Button
              variant="filled"
              onClick={handleAcceptSuggestion}
              loading={isProcessingReconcile}
              disabled={isProcessingSuggestion}
            >
              {t('bill.payment_reconcile.button.enter_payment_and_reconcile')}
            </Button>
            <Button
              variant="outlined"
              onClick={handleRejectSuggestion}
              loading={isProcessingDelete}
              disabled={isProcessingSuggestion}
            >
              {t('bill.payment_reconcile.reject')}
            </Button>
          </Flex>
        </Styled.ReconciliationSuggestionContent>
      </SubjectReconciliationSuggestion>
      <Space size="s24" />
    </>
  )
}
